<template>
  <router-view />
</template>
<script>
// import wx from 'weixin-js-sdk'
export default {
  data() {
    return {
    }
  },
  methods: {
  },
  created: function () {
    // var thisUrl = window.location.href
    // let data = {//url把#后面的字符remove掉   把后两位remove掉
    //   // url: thisUrl.substring(0,thisUrl.length-2)
    //   url:thisUrl.split('#')[0]
    // }
    // /**
    //  * 获取签名后初始化wxconfig
    //  */
    // this.$postQuery('/WeChat/getSdkSign', data).then((response) => {
    //   console.log("----------------------config-------------------")
    //   console.log(response);
    //   wx.config(response.obj);
    // })
  }
}
</script>>
<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  /* text-align: center; */
  color: #2c3e50;
}

#nav {
  padding: 30px;
}

#nav a {
  font-weight: bold;
  color: #2c3e50;
}

#nav a.router-link-exact-active {
  color: #42b983;
}
.card{
  width: 90%;
  margin: 0 auto;
  box-shadow: 0 8px 12px #ebedf0;
  padding: 15px 0;
  margin-top: 8px;
  border-radius: 5px;
  border: 1px solid #e0e0e0;
}
.clearFix{
  clear: both;
}
</style>
